import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "vip"
};
const _hoisted_2 = {
  class: "main-wrap vip-wrap"
};
const _hoisted_3 = {
  class: "vip-main-wrap"
};
const _hoisted_4 = {
  class: "card vip-card"
};
const _hoisted_5 = {
  class: "vip-info"
};
const _hoisted_6 = {
  class: "vip-attr"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "level-name"
}, "黄金会员", -1);
const _hoisted_8 = {
  class: "user-name"
};
const _hoisted_9 = {
  class: "card-flag"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "vip-status"
};
const _hoisted_12 = {
  class: "status-text"
};
const _hoisted_13 = {
  class: "card privilege-card"
};
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "开通立享 6+ 特权", -1);
const _hoisted_15 = {
  class: "card set-meal"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "选择特权时长", -1);
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "tag"
}, "尝鲜体验", -1);
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "duration"
}, "1个月", -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "actual-price"
}, "￥15", -1);
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "original-price"
}, "￥18.00/月", -1);
const _hoisted_21 = [_hoisted_17, _hoisted_18, _hoisted_19, _hoisted_20];
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "tag"
}, "畅享推荐", -1);
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "duration"
}, "3个月", -1);
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "actual-price"
}, "￥45", -1);
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "original-price"
}, "￥54.00/月", -1);
const _hoisted_26 = [_hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25];
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "tag"
}, "优享推荐", -1);
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "duration"
}, "6个月", -1);
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "actual-price"
}, "￥90", -1);
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "original-price"
}, "￥108.00/月", -1);
const _hoisted_31 = [_hoisted_27, _hoisted_28, _hoisted_29, _hoisted_30];
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "tag"
}, "尊享推荐", -1);
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "duration"
}, "12个月", -1);
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "actual-price"
}, "￥180", -1);
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "original-price"
}, "￥216.00/月", -1);
const _hoisted_36 = [_hoisted_32, _hoisted_33, _hoisted_34, _hoisted_35];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_grid_item = _resolveComponent("van-grid-item");
  const _component_van_grid = _resolveComponent("van-grid");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_nav_bar, {
    class: "user-nav-bar",
    title: $setup.title,
    border: false
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString($options.SessionUtil.getUserPhone()), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: require('@/assets/img/vip-card-flag.png')
  }, null, 8, _hoisted_10)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createTextVNode(" 您还不是会员，开通立享特权 "), _createVNode(_component_van_icon, {
    name: "arrow"
  })]), _createVNode(_component_van_button, {
    round: "",
    size: "small"
  }, {
    default: _withCtx(() => [_createTextVNode(" 立即开通 ")]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_van_grid, {
    border: false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/receive-coupon.png'),
      text: "月月领券"
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/priority-dispatch.png'),
      text: "优先派单"
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/vip-customer-service.png'),
      text: "VIP客服"
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/set-meal.png'),
      text: "会员套餐"
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/no-cancellation-fee.png'),
      text: "免取消费"
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/double-points.png'),
      text: "积分加倍"
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/gold-logo.png'),
      text: "黄金标识"
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/vip/more.png'),
      text: "更多权益"
    }, null, 8, ["icon"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", {
    class: _normalizeClass('choose ' + ($setup.isScrollLeft ? ' right-overflow' : ' left-overflow')),
    ref: "choose"
  }, [_createElementVNode("div", {
    class: _normalizeClass('item' + ($setup.months === 1 ? ' selected' : '')),
    onClick: _cache[0] || (_cache[0] = $event => $options.chooseDuration(1))
  }, _hoisted_21, 2), _createElementVNode("div", {
    class: _normalizeClass('item' + ($setup.months === 3 ? ' selected' : '')),
    onClick: _cache[1] || (_cache[1] = $event => $options.chooseDuration(3))
  }, _hoisted_26, 2), _createElementVNode("div", {
    class: _normalizeClass('item' + ($setup.months === 6 ? ' selected' : '')),
    onClick: _cache[2] || (_cache[2] = $event => $options.chooseDuration(6))
  }, _hoisted_31, 2), _createElementVNode("div", {
    class: _normalizeClass('item' + ($setup.months === 12 ? ' selected' : '')),
    onClick: _cache[3] || (_cache[3] = $event => $options.chooseDuration(12))
  }, _hoisted_36, 2)], 2), _createVNode(_component_van_button, {
    round: ""
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(15 * $setup.months) + "元/" + _toDisplayString($setup.months > 1 ? $setup.months + "个" : "") + "月 立享特权", 1)]),
    _: 1
  })])])])]);
}